import { render, staticRenderFns } from "./dy-button.vue?vue&type=template&id=0f8a5940&scoped=true"
import script from "./dy-button.vue?vue&type=script&lang=js"
export * from "./dy-button.vue?vue&type=script&lang=js"
import style0 from "./dy-button.vue?vue&type=style&index=0&id=0f8a5940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a5940",
  null
  
)

export default component.exports